import React, { useState, useRef, useEffect } from 'react';
import html2pdf from 'html2pdf.js';



import ConsultingForm from './form/ConsultingForm';
import ExcelForm from './form/ExcelForm';
import DeliveryForm from './form/DeliveryForm';
import HotelForm from './form/HotelForm';
import WordForm from './form/WordForm';
import MedicalForm from './form/MedicalForm';
import ContractorForm from './form/ContractorForm';
import FreelancerForm from './form/FreelancerForm';
import SalesForm from './form/SalesForm';
import ServiceForm from './form/ServiceForm';
import TemplateCard from './component/TemplateCard';
import DeliveryTemplate from './template/DeliveryTemplate';
import ServiceTemplate from './template/ServiceTemplate';
import ConsultingTemplate from './template/ConsultingTemplate';
import ContractorTemplate from './template/ContractorTemplate';
import FreelancerTemplate from './template/FreelancerTemplate';
import SalesTemplate from './template/SalesTemplate';
import ExcelTemplate from './template/ExcelTemplate';
import MedicalTemplate from './template/MedicalTemplate';
import HotelTemplate from './template/HotelTemplate';
import WordTemplate from './template/WordTemplate';

const templates = [
  { id: 'consulting', name: 'Consulting', component: ConsultingTemplate, form: ConsultingForm },
  { id: 'contractor', name: 'Contractor', component: ContractorTemplate, form: ContractorForm },
  { id: 'freelancer', name: 'Freelancer', component: FreelancerTemplate, form: FreelancerForm },
  { id: 'sales', name: 'Sales', component: SalesTemplate, form: SalesForm },
  { id: 'excel', name: 'Excel', component: ExcelTemplate, form: ExcelForm },
  { id: 'delivery', name: 'Delivery', component: DeliveryTemplate, form: DeliveryForm },
  { id: 'medical', name: 'Medical', component: MedicalTemplate, form: MedicalForm },
  { id: 'hotel', name: 'Hotel', component: HotelTemplate, form: HotelForm },
  { id: 'word', name: 'Word', component: WordTemplate, form: WordForm },
  { id: 'service', name: 'Service', component: ServiceTemplate, form: ServiceForm },
];

const Invoice = () => {
  const [view, setView] = useState('preview'); // preview | edit
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [invoiceData, setInvoiceData] = useState({});
  const printRef = useRef(null);

  const updateData = (key, value) => {
    setInvoiceData(prev => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    if (!printRef.current) return;

    const el = printRef.current;
    const a4HeightPx = 1122; 

    const contentHeight = el.scrollHeight;
    let scale = 1;

    if (contentHeight > a4HeightPx) {
      scale = a4HeightPx / contentHeight;
    }

    el.style.transform = `scale(${scale})`;
    el.style.transformOrigin = 'top left';
  }, [invoiceData, selectedTemplate, view]);

  const handleDownload = () => {
    if (!printRef.current) return;

    const opt = {
      margin: 0,
      filename: 'invoice.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: 0,
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait',
      },
      pagebreak: { mode: ['avoid-all'] }, // no multi-page
    };

    html2pdf().set(opt).from(printRef.current).save();
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-gray-50 px-2">

      {selectedTemplate && (
        <div className="w-full bg-white border-b px-6 py-1 flex justify-between items-center">
          <h1 className="text-xl font-bold text-gray-800 tracking-tight">
            Invoice Generator
          </h1>

          <div className="flex gap-2">
            <button
              onClick={() => setView('edit')}
              className={`px-4 py-2 rounded-md text-sm font-semibold transition
                ${view === 'edit'
                  ? 'bg-gray-800 text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
                }`}
            >
Invoice Generate           </button>

            <button
              onClick={() => setView('preview')}
              className={`px-4 py-2 rounded-md text-sm font-semibold transition
                ${view === 'preview'
                  ? 'bg-gray-800 text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
                }`}
            >
              Preview
            </button>

            <button
              onClick={handlePrint}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white  rounded-md text-sm font-semibold transition"
            >
              Print
            </button>

            <button
              onClick={handleDownload}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 
                         text-white rounded-md text-sm font-semibold transition"
            >
              Download PDF
            </button>
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto py-6">

       {!selectedTemplate && (
        <>
        <h4 className='mb-2'>Invoice Template</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 ">
            {templates.map((temp) => (
              <TemplateCard
                key={temp.id}
                name={temp.name}
                type={temp.id}
                TemplateComponent={temp.component}
                onSelect={() => setSelectedTemplate(temp)}
              />
            ))}
          </div>
          </>
        )}

        {selectedTemplate && (
          <div className="grid grid-cols-[150px_1fr] ">

            <div className="bg-white border rounded-lg p-3 h-[100vh] sticky top-0">
              <h3 className="text-xs font-bold text-gray-500 mb-2 uppercase">
                Templates
              </h3>
              <div className="space-y-1">
                {templates.map((temp) => (
                  <button
                    key={temp.id}
                    onClick={() => setSelectedTemplate(temp)}
                    className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium transition
                      ${selectedTemplate.id === temp.id
                        ? 'bg-blue-50 text-blue-600'
                        : 'hover:bg-gray-100 text-gray-700'
                      }`}
                  >
                    {temp.name}
                  </button>
                ))}
              </div>
            </div>

            <div className="w-full">

              {view === 'edit' && (
                <div className="bg-white p-6 rounded-md shadow-sm border w-full">
                  <selectedTemplate.form
                    data={invoiceData}
                    onUpdate={updateData}
                  />
                </div>
              )}

              {view === 'preview' && (
                <div>
                  <div
                    ref={printRef}
                    className="print-area"
                  >
                    <selectedTemplate.component data={invoiceData} />
                  </div>
                </div>
              )}

            </div>
          </div>
        )}
      </div>

      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-area, .print-area * {
              visibility: visible;
            }
            .print-area {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              transform: scale(1) !important;
            }
          }
        `}
      </style>

    </div>
  );
};

export default Invoice;
